import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { recordStatisticsEvent } from '../../../../services/statistics-service';
import relativeTime from '../../../../shared/relative-time';
import WireTitle from '../wire-title';
import ImageWithListenButton from '../shared/image-with-listen-button';
import useTheme from '../theme';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
  z-index: 1;
  border-radius: 4px 4px 60px 40px;
  box-shadow: 0px 26.5px 17.7px rgba(50, 50, 71, 0.14), 0px 26.6px 36.2px -17px rgba(50, 50, 71, 0.17);

  &:hover {
    cursor: pointer;
  }

  > div {
    width: 486px;
    height: 267px;
    padding: 26px 30px 0 0;
    margin-bottom: 0;
    border-radius: 4px 4px 0 0;

    ${props => props.theme.isROILarge && !props.theme.isROIMedium && `
      width: 369px;
      height: 203px;
    `};

    ${props => props.theme.isROIXSmall && `
      width: unset;
      height: unset;
    `};

    &.text-wrapper {
      height: min-content;
      background-color: #19202D;
      padding: 24px 24px 32px;
      border-radius: 0 0 60px 4px;
  
      > div > h2 {
        font-size: 24px;
        line-height: 120.5%;
  
        ${props => props.theme.isROIXLarge && `
          font-size: 29px;
        `};
  
        > button {
          color: #FFF;
        }
      }
  
      > p.wire-details {
        color: #8EA3B5;  
        font-size: 18px;
        font-weight: 700;
        text-transform: uppercase;
        line-height: 120%;
        margin: 0 0 8px 0;
  
        ${props => props.theme.isROIMobile && `
          font-size: 16px;
        `};
      }
    }
  }
`;

export default function Wire({ wire }) {
  const wireUrl = `/wires/${wire.slug}`;

  const handleClick = () => {
    recordStatisticsEvent({
      event: 'link_click',
      statisticable: 'wire',
      id: wire.id,
      clicked_url: `/wires/${wire.slug}`,
      page: window.location.pathname,
      custom_data: {
        section: 'series_header',
        page: 'series',
      },
    });
  };

  const wireClicked = e => {
    e && e.preventDefault();
    handleClick();
    window.location = wireUrl;
  };

  return (
    <Container onClick={wireClicked} theme={useTheme()}>
      {!!wire.primaryImageUrl
        && <ImageWithListenButton wire={wire} section="series_header" />}
      <div className="text-wrapper">
        <p className="wire-details">
          {relativeTime(wire.firstPublishedAt, false)}
        </p>
        <WireTitle wire={wire} onHeaderWire />
      </div>
    </Container>
  );
}

Wire.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    primaryImageUrl: PropTypes.string.isRequired,
    firstPublishedAt: PropTypes.string.isRequired,
    profile: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
  }).isRequired,
};
